import { render, staticRenderFns } from "./UserPaymentNewPreview.vue?vue&type=template&id=5e906a64&scoped=true"
import script from "./UserPaymentNewPreview.vue?vue&type=script&lang=js"
export * from "./UserPaymentNewPreview.vue?vue&type=script&lang=js"
import style0 from "./UserPaymentNewPreview.vue?vue&type=style&index=0&id=5e906a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e906a64",
  null
  
)

export default component.exports